(() => {
  if (window.CartGiftEligibility) return;

  const excludedProductIds = new Set(
    String(document.currentScript?.dataset.excludedProductIds || '')
      .split('|')
      .map((id) => id.trim())
      .filter(Boolean)
  );
  const isExcludedProduct = (productId) => excludedProductIds.has(String(productId));
  const isPaidItem = (item) =>
    String(item?.properties?._reward_gift || '') !== 'true' &&
    !isExcludedProduct(item?.product_id) &&
    Number(item?.quantity) > 0;
  const getPaidItems = (cart) => (cart?.items || []).filter(isPaidItem);
  const getPaidItemsCount = (cart) =>
    getPaidItems(cart).reduce((count, item) => count + Number(item.quantity), 0);

  window.CartGiftEligibility = Object.freeze({
    isExcludedProduct,
    isPaidItem,
    getPaidItems,
    getPaidItemsCount,
  });
})();
